import { formatPhone } from '../../domain/people';
import { BrandMark } from '../../ui/BrandMark';
import { Pattern } from './screens';
import s from './auth.module.css';

const STEPS = [
  'Нажмите «Войти через Telegram» — откроется приложение PASS24 в Telegram.',
  'Если попросит — поделитесь номером телефона, один раз.',
  'Нажмите «Открыть PASS24 в браузере» — и вы здесь.',
];

const TelegramIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M21.4 4.6 2.9 11.7c-1 .4-1 1.6.1 1.9l4.7 1.5 1.8 5.6c.2.7 1.1.9 1.6.4l2.6-2.4 4.7 3.5c.6.4 1.4.1 1.6-.6l3.2-15.2c.2-1-.8-1.8-1.8-1.4zM9.6 14.2l-.4 3.9-1.3-4.2 9.9-6.3-8.2 6.6z" />
  </svg>
);

/**
 * The app in an ordinary browser (#4218; replaced the «only in Telegram» screen of roadmap P1-8).
 * Signing in still happens in Telegram, so the steps say where the resident goes and how they come back.
 */
export function WebLoginScreen({ error, onStart }: { error?: string; onStart: () => void }) {
  return (
    <main className={s.screen}>
      <Pattern />
      <BrandMark />
      <h1 className={s.title}>Пропуска PASS24</h1>
      <p className={s.lead}>Заказ пропуска гостю, ссылка для гостя и связь с управляющей компанией — теперь и в браузере.</p>
      <ol className={s.steps}>
        {STEPS.map((text, i) => (
          <li key={i} className={s.step}>
            <span className={s.stepNo} aria-hidden="true">
              {i + 1}
            </span>
            {text}
          </li>
        ))}
      </ol>
      <div className={s.spacer} />
      <div className={s.actions}>
        {error && (
          <p className={s.error} role="alert">
            {error}
          </p>
        )}
        <button type="button" className={s.primary} onClick={onStart}>
          <TelegramIcon />
          Войти через Telegram
        </button>
        <p className={s.note}>Нужен Telegram на этом устройстве. Пароль и SMS не нужны.</p>
      </div>
    </main>
  );
}

export interface Account {
  name: string;
  phone: string;
}

/** A token this browser did not ask for: it could come from someone else's link, so the resident checks whose. */
export function ConfirmAccountScreen({ account, onConfirm, onReject }: { account: Account; onConfirm: () => void; onReject: () => void }) {
  return (
    <main className={s.screen}>
      <Pattern />
      <BrandMark />
      <h1 className={s.title}>Войти в этом браузере?</h1>
      <p className={s.lead}>{`${account.name}, ${formatPhone(account.phone)}`}</p>
      <p className={s.note}>Если вы сейчас не входили через Telegram или это не ваш номер — нажмите «Это не я».</p>
      <div className={s.spacer} />
      <div className={s.actions}>
        <button type="button" className={s.primary} onClick={onConfirm}>
          Да, войти
        </button>
        <button type="button" className={s.link} onClick={onReject}>
          Это не я
        </button>
      </div>
    </main>
  );
}
